import React, { useEffect, useRef } from 'react'
import { ActionButton, RfShell } from '../components/RfShell'
import { RfStatusBanner } from '../components/RfStatusBanner'
import { receivingContext, getReceiptQuantities, ReceivingFlowController } from '../flow'
import { InputSummary, ReceiptMetric, ScanForm, TaskHeader, FieldHint } from '../styles'

export const OverReceiveScreen = ({
  controller,
  embedded = false,
  onExit,
}: {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}) => {
  const { state, dispatch } = controller
  const q = getReceiptQuantities(state)
  const extra = Number(state.additionalEntry)
  const showNewTarget =
    state.additionalEntry.trim() !== '' &&
    Number.isSafeInteger(extra) &&
    extra > 0 &&
    Number.isSafeInteger(q.target + extra)
  const number = (value: number) => value.toLocaleString('en-US')
  const input = useRef<HTMLInputElement>(null)
  useEffect(() => {
    input.current?.focus()
  }, [])
  return (
    <RfShell
      title="Receiving"
      phase="Receiving"
      embedded={embedded}
      contextSummary={receivingContext(state)}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      actions={
        <ActionButton type="submit" form="over-receive-form">
          Continue
        </ActionButton>
      }
    >
      <TaskHeader>
        <h1>Over receive</h1>
      </TaskHeader>
      {state.status ? <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner> : null}
      <InputSummary>
        {q.target > 0 ? (
          <ReceiptMetric>
            <span>Received / planned</span>
            <strong>
              {number(q.received)} / {number(q.target)}
            </strong>
          </ReceiptMetric>
        ) : (
          <p>No ASN quantity</p>
        )}
        {q.additional > 0 ? (
          <FieldHint>
            Expected {number(q.expected)} + Additional {number(q.additional)}
          </FieldHint>
        ) : null}
      </InputSummary>
      <ScanForm
        id="over-receive-form"
        noValidate
        onSubmit={(event) => {
          event.preventDefault()
          dispatch({ type: 'submit-additional-quantity' })
        }}
      >
        <label htmlFor="additional-quantity">Additional quantity (eaches)</label>
        <input
          ref={input}
          id="additional-quantity"
          className="form-control"
          inputMode="numeric"
          value={state.additionalEntry}
          onChange={(event) => dispatch({ type: 'set-additional-quantity', value: event.target.value })}
        />
        {showNewTarget ? (
          <FieldHint>
            New planned quantity: <strong>{number(q.target + extra)}</strong>
          </FieldHint>
        ) : null}
      </ScanForm>
    </RfShell>
  )
}
